import i18n from "@/lang/i18n";
import { GdprErrorDTO } from "@/model/data.model";
import { AxiosError } from "axios";

export class GdprErrorHandler {
  private readonly UNKNOWN_STATUS = 400;
  constructor(private readonly error: AxiosError) {}

  private status(): number {
    if (this.hasResponse()) return this.error.response.status;
    return this.UNKNOWN_STATUS;
  }

  private hasResponse() {
    return this.error.response !== undefined;
  }

  private gdprSpecificMessage(): string {
    const errorBug: GdprErrorDTO[] = this.error.response.data;
    const messages: string[] = [];
    errorBug.forEach((err: GdprErrorDTO) => {
      messages.push(i18n.t(err.code));
    });
    if (!messages.length) return this.getGeneralErrorMessage();
    return messages.join(" ");
  }

  private getGeneralErrorMessage(): string {
    return i18n.t("gdpr_general_error");
  }

  get message() {
    if (this.status() === 409) return this.gdprSpecificMessage();
    return this.getGeneralErrorMessage();
  }
}
